import { API } from './constants';

// Una sola conexión SSE por pestaña, compartida por todos los componentes.
// El backend guarda una conexión por usuario y cierra la anterior al llegar
// otra, así que abrir varias EventSource hacía que se tumbaran entre sí.
let source = null;
let sourceToken = null;
let retryTimer = null;
let retryDelay = 1000;
const listeners = new Set();

function open() {
  source = new EventSource(`${API}/api/chat/sse?token=${encodeURIComponent(sourceToken)}`);
  source.onopen = () => { retryDelay = 1000; };
  source.onmessage = e => {
    let data;
    try { data = JSON.parse(e.data); } catch { return; }
    // Un listener que falle no debe impedir que los demás reciban el evento.
    listeners.forEach(l => { try { l(data); } catch (err) { console.error(err); } });
  };
  source.onerror = () => {
    // Ante errores de red EventSource reintenta solo; pero si el servidor
    // responde no-200 (p. ej. 502 durante un reinicio) queda CLOSED para siempre.
    if (source.readyState !== EventSource.CLOSED) return;
    source = null;
    clearTimeout(retryTimer);
    retryTimer = setTimeout(() => { if (listeners.size > 0 && !source) open(); }, retryDelay);
    retryDelay = Math.min(retryDelay * 2, 30000);
  };
}

function close() {
  clearTimeout(retryTimer);
  if (source) source.close();
  source = null;
  sourceToken = null;
  retryDelay = 1000;
}

export function subscribeSSE(token, listener) {
  if (sourceToken !== null && sourceToken !== token) close();
  if (!source) {
    sourceToken = token;
    clearTimeout(retryTimer);
    open();
  } else if (source.readyState === EventSource.OPEN) {
    // Quien se suscribe tarde no vio el 'connected' inicial; se lo reenviamos
    // para que haga su carga inicial igual que los demás.
    setTimeout(() => listener({ type: 'connected' }), 0);
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) close();
  };
}
